import React from 'react';

const Recipe = React.createContext({
	recipe: null
});

export default Recipe;